import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Dialog } from "primereact/dialog";
import { Button, TextAreaField, DropDownField } from "../../../helpers";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

const cancellationReasons = [
    { id: 1, label: 'Data Entry Mistake' },
    { id: 2, label: 'Seller Denied - MOQ [MOQ > SPO Qty]' },
    { id: 3, label: 'Seller Denied - Material Not Available' },
    { id: 4, label: 'Seller Denied - Price Change' }
]


const CancelSellerPO = (props) => {
    const [cancellationReason, setCancellationReason] = useState(null)
    const [remarks, setRemarks] = useState("")

    const dispatch = useDispatch()

    const handleOnChangeRemarks = (e) => {
        setRemarks(e.target.value)
    }

    const handleCancellationReason = (e) => {
        setCancellationReason(e.target.value)
    }

    const handleCloseCancelSellerPO = () => {
        setCancellationReason(null)
        setRemarks("")
        props.onHide()
    }

    const handleSubmitClick = async () => {
        if (!cancellationReason) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please select cancellation reason', life: 3000 }))
        }

        const trimmedRemarks = remarks.trim()
        if (!trimmedRemarks) {
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please enter remarks', life: 3000 }))
        }

        const reasonText = `Reason: ${cancellationReason}\nRemarks: ${trimmedRemarks}`;

        props.onSubmit(reasonText)
        setCancellationReason(null)
        setRemarks("")
    }

    const footerContent = () => {
        return (
            <div>
                <Button label="Cancel" severity="danger" outlined onClick={() => handleCloseCancelSellerPO()} />
                <Button label="Submit" severity="" outlined onClick={() => handleSubmitClick()} applyThrottle />
            </div>
        )
    }

    return (
        <>
            <Dialog className="send-email-modal" header="Cancel Seller PO" visible={props.visible} footer={footerContent} style={{ width: '50vw', minHeight: "35%" }} onHide={() => handleCloseCancelSellerPO()}>
                <div className="grid">
                    <div className="flex flex-column col-12 md:col-6">
                        <DropDownField name="cancellationReason" labelText="Cancellation Reason" placeholder={"Please Select"} options={cancellationReasons} optionLabel="label" optionValue="label" value={cancellationReason} onChange={(e)=>handleCancellationReason(e)} showClear required />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-12 lg:mb-0">
                        <TextAreaField name="remarks" labelText="Remarks" rows={3} placeholder="Enter Remarks" value={remarks} onChange={(e) => handleOnChangeRemarks(e)} required />
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default CancelSellerPO